export const sharedTranslations = {
  ru: {
    'shared.importHistory.import.file_uploaded': 'Файл загружен',
    'shared.importHistory.import.bank_format_detected': 'Банк/формат определён',
    'shared.importHistory.import.parsing_completed': 'Parsing завершён',
    'shared.importHistory.import.quality_report_created': 'Quality report создан',
    'shared.importHistory.import.duplicates_found': 'Дубли найдены',
    'shared.importHistory.Import': 'Импорт',
    'shared.importHistory.Match': 'Сопоставление контрагента',
    'shared.importHistory.Updated': 'Обновление',
    'shared.importHistory.Allocate': 'Распределение создано',
    'shared.importHistory.PostPayment': 'Проведение в очереди',
    'shared.importHistory.Approve': 'Подтверждение',
    'shared.importHistory.Cancel': 'Отмена',
    'shared.importHistory.Reconcile': 'Сверка',
    'shared.reason.required': 'Укажите причину действия.',
    'shared.reason.tooShort': 'Причина должна быть не короче {min} символов.',
    'shared.reason.tooLong': 'Причина должна быть не длиннее {max} символов.',
    'shared.reason.noSecrets': 'Не вставляйте в причину пароли, токены, API keys или raw credentials.',
    'shared.reason.notGeneric': 'Укажите конкретную проверяемую причину, а не шаблонный текст.',
    'components.fileUpload.dropRelease': 'Отпустите файл для загрузки банковской выписки',
    'components.fileUpload.uploading': 'Загружаем файл…',
    'components.fileUpload.dropHere': 'Отпустите файл для загрузки',
    'components.fileUpload.dragOrClick': 'Перетащите файл сюда или нажмите для выбора',
    'components.fileUpload.rejected': 'Файл не принят.',
    'components.fileUpload.formats': 'CSV, Excel, TXT, PDF — формат определится на сервере',
    'components.fileUpload.selectFile': 'Выбрать файл',
    'components.searchableSelect.placeholder': 'Начните вводить для поиска…',
    'components.searchableSelect.empty': 'Ничего не найдено',
    'components.supportedBanks.extensions': 'Расширения: {extensions}',
    'components.supportedBanks.exampleFile': 'Пример файла: {names}',
    'components.supportedBanks.technicalDetails': 'Технические детали',
    'components.supportedBanks.notes': 'Примечания',
    'components.supportedBanks.title': 'Поддерживаемые банки',
    'components.supportedBanks.loading': 'Загружаем поддерживаемые банки…',
    'components.supportedBanks.empty': 'Пока нет опубликованных банковских форматов.',
    'components.supportedBanks.upload': 'Загрузить выписку',
    'components.supportedBanks.hint': 'Выберите банк и убедитесь, что файл выгружен из нужного раздела интернет-банка. Если формат не совпадает, импорт попадёт в проверку.',
    'components.supportedBanks.supportedExtensions': 'Поддерживаемые расширения: {extensions}',
    'components.supportedBanks.carousel.caption': 'Работаем с выписками банков',
    'components.supportedBanks.carousel.aria': 'Поддерживаемые банки',
    'components.supportedBanks.strip.caption': 'Поддерживаемые банки и форматы выписок',
    'components.supportedBanks.strip.aria': 'Логотипы поддерживаемых банков',
    'components.importQuality.loading': 'Качество импортов…',
    'components.importQuality.title': 'Качество импортов',
    'components.importQuality.allImports': 'Все импорты',
    'components.importQuality.needsReview.title': 'Требуют проверки',
    'components.importQuality.needsReview.description': 'Низкая уверенность или расхождения',
    'components.importQuality.unsupported.title': 'Неподдерживаемые',
    'components.importQuality.unsupported.description': 'Формат не распознан',
    'components.importQuality.duplicates.title': 'Возможные дубли',
    'components.importQuality.duplicates.description': 'Кандидаты на дублирование',
    'components.importQuality.lastSuccess.title': 'Последний успешный',
    'components.importQuality.lastSuccess.empty': 'Пока нет успешных импортов',
    'shared.capability.csv': 'CSV-файл',
    'shared.capability.excel': 'Excel-файл',
    'shared.capability.xlsx': 'Excel-файл',
    'shared.capability.txt': 'TXT-файл',
    'shared.capability.pdf': 'PDF-выписка',
    'shared.capability.debit_credit_columns': 'Отдельные колонки Дебет/Кредит',
    'shared.capability.signed_amount': 'Сумма со знаком +/-',
    'shared.capability.counterparty_extraction': 'Распознаёт контрагента',
    'shared.capability.balance_validation': 'Проверяет баланс',
    'shared.capability.duplicate_detection': 'Проверяет возможные дубли',
    'shared.capability.transaction_reference': 'Читает банковские референсы',
    'shared.capability.multi_account': 'Поддерживает несколько счетов',
    'shared.capability.cr_db_suffix': 'Суффиксы CR/DB в суммах',
    'shared.adapterStatus.productionReady.label': 'Готово к работе',
    'shared.adapterStatus.productionReady.description': 'Формат стабилен для регулярной загрузки',
    'shared.adapterStatus.beta.label': 'Бета',
    'shared.adapterStatus.beta.description': 'Можно использовать, но проверьте первые импорты',
    'shared.adapterStatus.experimental.label': 'Экспериментально',
    'shared.adapterStatus.experimental.description': 'Нужна ручная проверка результата',
    'shared.confidence.productionReady.label': 'Высокая',
    'shared.confidence.productionReady.description': 'Формат надёжно определяется при загрузке',
    'shared.confidence.beta.label': 'Средняя',
    'shared.confidence.beta.description': 'Определение формата обычно верное, но возможны пограничные случаи',
    'shared.confidence.experimental.label': 'Низкая',
    'shared.confidence.experimental.description': 'Автоопределение может ошибаться — проверяйте результат импорта',
    'shared.uploadHint.debitCreditColumns': 'Подходит для CSV/Excel выгрузки с отдельными колонками Debit и Credit.',
    'shared.uploadHint.counterpartyExtraction': 'Система попробует определить контрагента из описания операции.',
    'shared.uploadHint.balanceValidation': 'После загрузки будет проверен баланс выписки.',
    'shared.uploadHint.default': 'Загрузите файл в указанном формате; банк и формат определятся автоматически.',
  },
  en: {
    'shared.importHistory.import.file_uploaded': 'File uploaded',
    'shared.importHistory.import.bank_format_detected': 'Bank/format detected',
    'shared.importHistory.import.parsing_completed': 'Parsing completed',
    'shared.importHistory.import.quality_report_created': 'Quality report created',
    'shared.importHistory.import.duplicates_found': 'Duplicates found',
    'shared.importHistory.Import': 'Import',
    'shared.importHistory.Match': 'Counterparty match',
    'shared.importHistory.Updated': 'Update',
    'shared.importHistory.Allocate': 'Allocation created',
    'shared.importHistory.PostPayment': 'Posting queued',
    'shared.importHistory.Approve': 'Approval',
    'shared.importHistory.Cancel': 'Cancel',
    'shared.importHistory.Reconcile': 'Reconciliation',
    'shared.reason.required': 'Enter a reason for this action.',
    'shared.reason.tooShort': 'Reason must be at least {min} characters.',
    'shared.reason.tooLong': 'Reason must be at most {max} characters.',
    'shared.reason.noSecrets': 'Do not include passwords, tokens, API keys, or raw credentials in the reason.',
    'shared.reason.notGeneric': 'Provide a specific verifiable reason, not placeholder text.',
    'components.fileUpload.dropRelease': 'Release the file to upload a bank statement',
    'components.fileUpload.uploading': 'Uploading file…',
    'components.fileUpload.dropHere': 'Release file to upload',
    'components.fileUpload.dragOrClick': 'Drag a file here or click to select',
    'components.fileUpload.rejected': 'File not accepted.',
    'components.fileUpload.formats': 'CSV, Excel, TXT, PDF — format is detected on the server',
    'components.fileUpload.selectFile': 'Select file',
    'components.searchableSelect.placeholder': 'Start typing to search…',
    'components.searchableSelect.empty': 'Nothing found',
    'components.supportedBanks.extensions': 'Extensions: {extensions}',
    'components.supportedBanks.exampleFile': 'Example file: {names}',
    'components.supportedBanks.technicalDetails': 'Technical details',
    'components.supportedBanks.notes': 'Notes',
    'components.supportedBanks.title': 'Supported banks',
    'components.supportedBanks.loading': 'Loading supported banks…',
    'components.supportedBanks.empty': 'No published bank formats yet.',
    'components.supportedBanks.upload': 'Upload statement',
    'components.supportedBanks.hint': 'Choose a bank and ensure the file is exported from the correct online banking section. If the format does not match, the import will need review.',
    'components.supportedBanks.supportedExtensions': 'Supported extensions: {extensions}',
    'components.supportedBanks.carousel.caption': 'Bank statements we support',
    'components.supportedBanks.carousel.aria': 'Supported banks',
    'components.supportedBanks.strip.caption': 'Supported banks and statement formats',
    'components.supportedBanks.strip.aria': 'Supported bank logos',
    'components.importQuality.loading': 'Import quality…',
    'components.importQuality.title': 'Import quality',
    'components.importQuality.allImports': 'All imports',
    'components.importQuality.needsReview.title': 'Needs review',
    'components.importQuality.needsReview.description': 'Low confidence or discrepancies',
    'components.importQuality.unsupported.title': 'Unsupported',
    'components.importQuality.unsupported.description': 'Format not recognized',
    'components.importQuality.duplicates.title': 'Possible duplicates',
    'components.importQuality.duplicates.description': 'Duplicate candidates',
    'components.importQuality.lastSuccess.title': 'Last successful',
    'components.importQuality.lastSuccess.empty': 'No successful imports yet',
    'shared.capability.csv': 'CSV file',
    'shared.capability.excel': 'Excel file',
    'shared.capability.xlsx': 'Excel file',
    'shared.capability.txt': 'TXT file',
    'shared.capability.pdf': 'PDF statement',
    'shared.capability.debit_credit_columns': 'Separate Debit/Credit columns',
    'shared.capability.signed_amount': 'Signed +/- amount',
    'shared.capability.counterparty_extraction': 'Extracts counterparty',
    'shared.capability.balance_validation': 'Validates balance',
    'shared.capability.duplicate_detection': 'Checks for possible duplicates',
    'shared.capability.transaction_reference': 'Reads bank references',
    'shared.capability.multi_account': 'Supports multiple accounts',
    'shared.capability.cr_db_suffix': 'CR/DB amount suffixes',
    'shared.adapterStatus.productionReady.label': 'Production ready',
    'shared.adapterStatus.productionReady.description': 'Format is stable for regular uploads',
    'shared.adapterStatus.beta.label': 'Beta',
    'shared.adapterStatus.beta.description': 'Usable, but verify first imports',
    'shared.adapterStatus.experimental.label': 'Experimental',
    'shared.adapterStatus.experimental.description': 'Manual result review required',
    'shared.confidence.productionReady.label': 'High',
    'shared.confidence.productionReady.description': 'Format is reliably detected on upload',
    'shared.confidence.beta.label': 'Medium',
    'shared.confidence.beta.description': 'Format detection is usually correct, edge cases possible',
    'shared.confidence.experimental.label': 'Low',
    'shared.confidence.experimental.description': 'Auto-detection may fail — review import results',
    'shared.uploadHint.debitCreditColumns': 'Suitable for CSV/Excel exports with separate Debit and Credit columns.',
    'shared.uploadHint.counterpartyExtraction': 'The system will try to detect the counterparty from the transaction description.',
    'shared.uploadHint.balanceValidation': 'Statement balance will be validated after upload.',
    'shared.uploadHint.default': 'Upload a file in the specified format; bank and format are detected automatically.',
  },
  id: {
    'shared.importHistory.import.file_uploaded': 'File diunggah',
    'shared.importHistory.import.bank_format_detected': 'Bank/format terdeteksi',
    'shared.importHistory.import.parsing_completed': 'Parsing selesai',
    'shared.importHistory.import.quality_report_created': 'Laporan kualitas dibuat',
    'shared.importHistory.import.duplicates_found': 'Duplikat ditemukan',
    'shared.importHistory.Import': 'Impor',
    'shared.importHistory.Match': 'Pencocokan rekanan',
    'shared.importHistory.Updated': 'Pembaruan',
    'shared.importHistory.Allocate': 'Alokasi dibuat',
    'shared.importHistory.PostPayment': 'Pencatatan dalam antrean',
    'shared.importHistory.Approve': 'Persetujuan',
    'shared.importHistory.Cancel': 'Batal',
    'shared.importHistory.Reconcile': 'Rekonsiliasi',
    'shared.reason.required': 'Masukkan alasan untuk tindakan ini.',
    'shared.reason.tooShort': 'Alasan harus minimal {min} karakter.',
    'shared.reason.tooLong': 'Alasan harus maksimal {max} karakter.',
    'shared.reason.noSecrets': 'Jangan sertakan kata sandi, token, API key, atau kredensial mentah dalam alasan.',
    'shared.reason.notGeneric': 'Berikan alasan spesifik yang dapat diverifikasi, bukan teks placeholder.',
    'components.fileUpload.dropRelease': 'Lepaskan file untuk mengunggah rekening koran',
    'components.fileUpload.uploading': 'Mengunggah file…',
    'components.fileUpload.dropHere': 'Lepaskan file untuk mengunggah',
    'components.fileUpload.dragOrClick': 'Seret file ke sini atau klik untuk memilih',
    'components.fileUpload.rejected': 'File tidak diterima.',
    'components.fileUpload.formats': 'CSV, Excel, TXT, PDF — format dideteksi di server',
    'components.fileUpload.selectFile': 'Pilih file',
    'components.searchableSelect.placeholder': 'Mulai mengetik untuk mencari…',
    'components.searchableSelect.empty': 'Tidak ada hasil',
    'components.supportedBanks.extensions': 'Ekstensi: {extensions}',
    'components.supportedBanks.exampleFile': 'Contoh file: {names}',
    'components.supportedBanks.technicalDetails': 'Detail teknis',
    'components.supportedBanks.notes': 'Catatan',
    'components.supportedBanks.title': 'Bank yang didukung',
    'components.supportedBanks.loading': 'Memuat bank yang didukung…',
    'components.supportedBanks.empty': 'Belum ada format bank yang dipublikasikan.',
    'components.supportedBanks.upload': 'Unggah rekening koran',
    'components.supportedBanks.hint': 'Pilih bank dan pastikan file diekspor dari bagian internet banking yang benar. Jika format tidak cocok, impor akan perlu ditinjau.',
    'components.supportedBanks.supportedExtensions': 'Ekstensi didukung: {extensions}',
    'components.supportedBanks.carousel.caption': 'Rekening koran bank yang kami dukung',
    'components.supportedBanks.carousel.aria': 'Bank yang didukung',
    'components.supportedBanks.strip.caption': 'Bank dan format rekening koran yang didukung',
    'components.supportedBanks.strip.aria': 'Logo bank yang didukung',
    'components.importQuality.loading': 'Kualitas impor…',
    'components.importQuality.title': 'Kualitas impor',
    'components.importQuality.allImports': 'Semua impor',
    'components.importQuality.needsReview.title': 'Perlu ditinjau',
    'components.importQuality.needsReview.description': 'Keyakinan rendah atau ketidaksesuaian',
    'components.importQuality.unsupported.title': 'Tidak didukung',
    'components.importQuality.unsupported.description': 'Format tidak dikenali',
    'components.importQuality.duplicates.title': 'Kemungkinan duplikat',
    'components.importQuality.duplicates.description': 'Kandidat duplikat',
    'components.importQuality.lastSuccess.title': 'Terakhir berhasil',
    'components.importQuality.lastSuccess.empty': 'Belum ada impor berhasil',
    'shared.capability.csv': 'File CSV',
    'shared.capability.excel': 'File Excel',
    'shared.capability.xlsx': 'File Excel',
    'shared.capability.txt': 'File TXT',
    'shared.capability.pdf': 'Rekening koran PDF',
    'shared.capability.debit_credit_columns': 'Kolom Debit/Kredit terpisah',
    'shared.capability.signed_amount': 'Jumlah bertanda +/-',
    'shared.capability.counterparty_extraction': 'Mengekstrak rekanan',
    'shared.capability.balance_validation': 'Memvalidasi saldo',
    'shared.capability.duplicate_detection': 'Memeriksa kemungkinan duplikat',
    'shared.capability.transaction_reference': 'Membaca referensi bank',
    'shared.capability.multi_account': 'Mendukung beberapa rekening',
    'shared.capability.cr_db_suffix': 'Akhiran jumlah CR/DB',
    'shared.adapterStatus.productionReady.label': 'Siap produksi',
    'shared.adapterStatus.productionReady.description': 'Format stabil untuk unggahan rutin',
    'shared.adapterStatus.beta.label': 'Beta',
    'shared.adapterStatus.beta.description': 'Dapat digunakan, tetapi verifikasi impor pertama',
    'shared.adapterStatus.experimental.label': 'Eksperimental',
    'shared.adapterStatus.experimental.description': 'Perlu pemeriksaan hasil manual',
    'shared.confidence.productionReady.label': 'Tinggi',
    'shared.confidence.productionReady.description': 'Format terdeteksi andal saat unggah',
    'shared.confidence.beta.label': 'Sedang',
    'shared.confidence.beta.description': 'Deteksi format biasanya benar, kasus tepi mungkin terjadi',
    'shared.confidence.experimental.label': 'Rendah',
    'shared.confidence.experimental.description': 'Deteksi otomatis bisa salah — periksa hasil impor',
    'shared.uploadHint.debitCreditColumns': 'Cocok untuk ekspor CSV/Excel dengan kolom Debit dan Credit terpisah.',
    'shared.uploadHint.counterpartyExtraction': 'Sistem akan mencoba mendeteksi rekanan dari deskripsi transaksi.',
    'shared.uploadHint.balanceValidation': 'Saldo rekening koran akan divalidasi setelah unggah.',
    'shared.uploadHint.default': 'Unggah file dalam format yang ditentukan; bank dan format dideteksi otomatis.',
  },
} as const;
